exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".left-aside[data-v-5558bdaf]{width:250px;background:#fff;background-repeat:repeat-y}.navigation[data-v-5558bdaf]{padding:0}.divider[data-v-5558bdaf]{margin-top:10px;list-style-type:none;border-bottom:1px solid #ececec;padding-bottom:6px}.divider span[data-v-5558bdaf]{font-size:15px;font-weight:700;color:#fff;margin:20px 20px -15px}.sidebar[data-v-5558bdaf]{display:block;font-size:14px;letter-spacing:1px}.content[data-v-5558bdaf]{display:block;width:auto;overflow-x:hidden;padding:0 15px}.badge-success[data-v-5558bdaf]{background-color:#22d69d}.badge[data-v-5558bdaf]{padding:.6em .7em;border-radius:.75rem}.nav_profile[data-v-5558bdaf]{border-bottom:1px solid #eee}.disabled-custom-class[data-v-5558bdaf]{pointer-events:none;opacity:.8;background:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5558bdaf","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouts/left-side/default/left-side.vue
// module id = jAwh
// module chunks = 1